import "date-fns";
import jaLocale from "date-fns/locale/ja";
import format from "date-fns/format";
import React from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { makeStyles, createStyles } from "@material-ui/core";
import { DateTypeSelect } from "./DateTypeSelect";

// Note:
// @date-io/date-fns は、バージョン1.x をインストールすること
// [参考]
//   Date-io v2: Uncaught RangeError: Format string contains an unescaped latin alphabet character `n` #1440
//   https://github.com/mui-org/material-ui-pickers/issues/1440

/** スタイル定義 */
const useStyles = makeStyles(() =>
  createStyles({
    container: {},
    label: {},
    range: {
      display: "flex",
      flexDirection: "column",
    },
    datePicker: {
      marginLeft: "0.6rem",
      width: "9rem",
    },
  })
);

interface Props {
  dateType: string;
  handleDateTypeChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  selectedFromDate: Date | null;
  setSelectedFromDate: React.Dispatch<Date | null>;
  selectedToDate: Date | null;
  setSelectedToDate: React.Dispatch<Date | null>;
}

//------------------------------
// カレンダーの日本語設定
class ExtendedUtils extends DateFnsUtils {
  getCalendarHeaderText(date: any) {
    return format(date, "yyyy MMM", { locale: this.locale });
  }
}

/**
 * 日付範囲ピッカー
 *
 * @material-ui/pickers
 * https://material-ui.com/components/pickers/#material-ui-pickers
 */
export function DateRangePicker(props: Props) {
  const classes = useStyles();

  //------------------------------
  // 日付種類
  // [State]
  const { dateType } = props;
  // [Handler]
  const { handleDateTypeChange } = props;

  //------------------------------
  // 日付範囲
  // [State]
  const { selectedFromDate, setSelectedFromDate } = props;
  const { selectedToDate, setSelectedToDate } = props;

  //--------------------
  // コンポーネント
  return (
    <div className={classes.container}>
      <DateTypeSelect
        dateType={dateType}
        handleDateTypeChange={handleDateTypeChange}
      />
      <div className={classes.range}>
        <MuiPickersUtilsProvider utils={ExtendedUtils} locale={jaLocale}>
          <Grid container>
            <KeyboardDatePicker
              disableToolbar
              className={classes.datePicker}
              size="small"
              variant="dialog"
              format="yyyy/MM/dd"
              margin="dense"
              id="date-picker-inline-from"
              label="From"
              value={selectedFromDate}
              onChange={(date: Date | null) => {
                setSelectedFromDate(date);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              okLabel="決定"
              cancelLabel="キャンセル"
            />
          </Grid>
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider utils={ExtendedUtils} locale={jaLocale}>
          <Grid container>
            <KeyboardDatePicker
              disableToolbar
              className={classes.datePicker}
              size="small"
              variant="dialog"
              format="yyyy/MM/dd"
              margin="dense"
              id="date-picker-inline-to"
              label="To"
              value={selectedToDate}
              onChange={(date: Date | null) => {
                setSelectedToDate(date);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              okLabel="決定"
              cancelLabel="キャンセル"
            />
          </Grid>
        </MuiPickersUtilsProvider>
      </div>
    </div>
  );
}
